import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';
import './recommender-boost.scss';
import '../shared/cta/cta';

import { getText, appendText } from '../../assets/js/text-renderer';

document.addEventListener('DOMContentLoaded', async () => {
  if (
    DEVELOPMENT || (
    window['__PRERENDER_INJECTED'] &&
    window['__PRERENDER_INJECTED'].render_text)
  ) await loadText();
});

const loadText = async () => {
  const ctaButtonsContent = await getText('platform/shared/cta-buttons');
  const ctaButtons = ctaButtonsContent.stories[0].content;
  const data = await getText('platform/recommender-boost');  
  const content = data.stories[0].content;
  
  console.log('ctaButtons', ctaButtons);
  console.log('content', content);

  setHeaderContent(content, ctaButtons);
  setIntroContent(content);
  setHowWorksContent(content);
  setFeaturesContent(content);
  setSolutionContent(content);
  await setCustomCtaContent();

  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'keywords' })
  );
  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'content' })
  );
};

function setHeaderContent(content, ctaButtons) {
  appendText(content.header_title, 'header-title');
  appendText(ctaButtons.start_trial_btn, 'hero-cta-trial-button');
  appendText(ctaButtons.book_demo_btn, 'hero-cta-demo-button');
  appendText(content.summary, 'summary');
}

function setIntroContent(content) {
  appendText(content.intro_items[0].text, 'intro-item-0');
  appendText(content.intro_items[1].text, 'intro-item-1');
  appendText(content.intro_items[2].text, 'intro-item-2');
  appendText(content.intro_items[3].text, 'intro-item-3');
  appendText(content.intro_items[4].text, 'intro-item-4');
}

function setHowWorksContent(content) {
  appendText(content.how_works_title, 'how-works-title');
  appendText(content.how_works_description, 'how-works-description');
}

function setFeaturesContent(content) {
  appendText(content.features[0].text, 'feature-item-0');
  appendText(content.features[1].text, 'feature-item-1');
  appendText(content.features[2].text, 'feature-item-2');
}

function setSolutionContent(content) {
  appendText(content.solution, 'solution');
}

async function setCustomCtaContent() {
  const ctaData = await getText('platform/shared/cta');
  const ctaContent = ctaData.stories[0].content.block[0];

  const customCtaContainer = document.getElementById('custom-cta');
  const customCtaEl = document.createElement('custom-cta');
  customCtaEl.setAttribute('title', ctaContent.title)
  customCtaEl.setAttribute('description', ctaContent.description)
  customCtaEl.setAttribute('primary-button-text', ctaContent.btn_primary)
  customCtaEl.setAttribute('primary-button-url', '/plataforma/start-trial/')
  customCtaEl.setAttribute('secondary-button-text', ctaContent.btn_secondary)
  customCtaEl.setAttribute('secondary-button-url', '/plataforma/book-demo-form/')
  customCtaContainer.appendChild(customCtaEl);

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "cta" })
  );
};